/**
 * Hand-written example request and response for an endpoint the catalog's
 * authored copy does not cover, one JSON file per SKU at
 * `./<platform>/<sku>.json`. They load lazily, one file per endpoint page, so
 * they never ride in the bundle every other page ships.
 */
interface SampleFile {
  /** the request body */
  input: Record<string, unknown>;
  /** the response's `data`, wrapped in the gateway's `{ found, data }` envelope here */
  data: unknown;
}

export interface EndpointSample {
  inputExample: string;
  sampleResponse: string;
}

const files = import.meta.glob<SampleFile>('./*/*.json', { import: 'default' });

/** The endpoint's hand-written sample, or null when it has none. */
export const loadEndpointSample = async (sku: string): Promise<EndpointSample | null> => {
  const load = files[`./${sku.split('.')[0]}/${sku}.json`];
  if (!load) return null;
  const { input, data } = await load();
  return {
    inputExample: JSON.stringify(input, null, 2),
    sampleResponse: JSON.stringify({ found: true, data }, null, 2),
  };
};
